import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWeechat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=WeChat Pay",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Vector",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M21.7315 13.7889C21.6549 13.8275 21.5765 13.846 21.4813 13.846C21.2684 13.846 21.0947 13.7317 20.9976 13.5604L20.9584 13.4849L19.4329 10.2053C19.4142 10.1667 19.4142 10.1298 19.4142 10.0912C19.4142 9.93824 19.53 9.82398 19.685 9.82398C19.7429 9.82398 19.8008 9.84242 19.8587 9.88109L21.6549 11.1395C21.7893 11.215 21.9443 11.2721 22.1179 11.2721C22.215 11.2721 22.3103 11.2537 22.4074 11.215L30.8304 7.51727C29.3235 5.76328 26.8326 4.61914 24.0113 4.61914C19.4142 4.61914 15.6667 7.68863 15.6667 11.4804C15.6667 13.5383 16.7871 15.4065 18.5442 16.6649C18.6785 16.7607 18.7756 16.9321 18.7756 17.1033C18.7756 17.1605 18.7569 17.2176 18.7365 17.2747C18.6021 17.7887 18.3687 18.6289 18.3687 18.6658C18.35 18.7228 18.3293 18.7984 18.3293 18.8758C18.3293 19.0287 18.4451 19.1429 18.6001 19.1429C18.658 19.1429 18.7159 19.1245 18.7551 19.0858L20.57 18.0375C20.7045 17.9619 20.8595 17.9048 21.0145 17.9048C21.0909 17.9048 21.1881 17.9232 21.2647 17.9435C22.1142 18.1904 23.0422 18.3249 23.9889 18.3249C28.586 18.3249 32.3334 15.2554 32.3334 11.4637C32.3334 10.3196 31.9861 9.23435 31.3868 8.28006L21.7893 13.7502L21.7315 13.7888V13.7889Z",
				fill: "#09BB07"
			})
		})
	}) })
});
export default SvgWeechat;
